import { createAsyncThunk } from "@reduxjs/toolkit";
import { APICore } from "../../helpers/api/apiCore";
import * as Url from "../../helpers/api/ApiEndpoint";
import { showError, showSuccess } from "../../helpers/toaster";
import { constructQueryString } from "../../helpers/Functions";

const api = new APICore();

export const connectTikTokAccount = createAsyncThunk(
  "tikTok/connectTikTokAccount",
  async (data, { rejectWithValue }) => {
    console.log({data})
    try {
      const response = await api.create(Url.CONNECT_TIKTOK, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const createTikTokPost = createAsyncThunk(
  "tikTok/createTikTokPost",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.create(Url.CREATE_TIKTOK_POST, data);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getTikTokPost = createAsyncThunk(
  "tikTok/getTikTokPost",
  async (data, { rejectWithValue }) => {
    console.log({ data });
    try {
      const query = constructQueryString(data);
      const response = await api.get(`${Url.GET_TIKTOK_POST}?${query}`);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getTikTokAuthUrl = createAsyncThunk(
  "tikTok/getTikTokAuthUrl",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${Url.GET_TIKTOK_AUTH_URL}`
      );
      // showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);

export const getTikTokAuthToken = createAsyncThunk(
  "tikTok/getTikTokAuthToken",
  async (data, { rejectWithValue }) => {
    try {
      let url;
      if (data.oauth_token && data.oauth_verifier) {
        // OAuth 1.0a flow
        url = `${Url.GET_TIKTOK_AUTH_TOKEN}?oauth_token=${data.oauth_token}&oauth_verifier=${data.oauth_verifier}`;
      } else if (data.code) {
        // OAuth 2.0 flow
        url = `${Url.GET_TIKTOK_AUTH_TOKEN}?code=${data.code}`;
      } else {
        throw new Error('Missing required OAuth parameters');
      }
      
      const response = await api.get(url);
      showSuccess(response.data.message);
      return response.data;
    } catch (error) {
      showError(error);
      // return rejectWithValue(error);
    }
  }
);
